import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import { Grid } from "@mui/material";
import { useContext, useEffect } from "react";
import { ProviderProjectDashboard } from "../ProjectSupportDashboard";

const ChartSectionJournal = () => {

    const {
        lstJournalChart,
    } = useContext(ProviderProjectDashboard);


    useEffect(() => {
        ChartSectionJournal();
    }, [lstJournalChart])

    const ChartSectionJournal = () => {

        am4core.addLicense("CH208466903"); //รหัสรายเส้นใช้ไม่ให้ขึ้นเส้นโลโก้
        let chart = am4core.create("ChartSectionJournal", am4charts.XYChart);

        chart.colors.list = [
            am4core.color("#cb6ce6"),
            am4core.color("#8c52ff"),
        ];

        const arrData = lstJournalChart.map((item) => {
            let resultData = {
                "year": item.sYear,
                "National": item.nNational,
                "International": item.nInternational
            };
            return resultData;
        });
        chart.data = arrData

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 20;

        var title = chart.titles.create();
        title.text = "จำนวนโครงการที่ตีพิมพ์ในวารสารวิชาการ";
        title.fontSize = 20;
        title.marginBottom = 20;


        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.min = 0;
        valueAxis.extraMax = 0.1;
        valueAxis.strictMinMax = true;
        valueAxis.calculateTotals = true;
        valueAxis.numberFormatter.numberFormat = '#,###'

        // Create series
        function createSeries(field, name, stacked) {
            let series = chart.series.push(new am4charts.ColumnSeries());
            series.dataFields.valueY = field;
            series.dataFields.categoryX = "year";
            series.name = name;
            series.columns.template.tooltipText = "{name}: [bold]{valueY}[/] โครงการ";
            series.stacked = stacked;
            series.columns.template.width = am4core.percent(50);

            let bullet = series.bullets.push(new am4charts.LabelBullet())
            bullet.interactionsEnabled = false
            bullet.dy = 20;
            bullet.label.text = '{valueY}'
            bullet.label.fill = am4core.color('#ffffff')
        }

        createSeries("National", "ระดับชาติ", false);
        createSeries("International", "ระดับนานาชาติ", false);

        // Add legend
        chart.legend = new am4charts.Legend()
        chart.legend.position = 'top'
        chart.legend.paddingBottom = 20
        chart.legend.labels.template.maxWidth = 100
    }
    return (
        <>
            <Grid item xs={12} md={12}>
                <div id="ChartSectionJournal" style={{ width: "100%", height: "500px" }}></div>
            </Grid>
        </>
    )
}
export default ChartSectionJournal